import { createContext } from "react";

export const darkTheme = {
	palette: {
		primary: { main: "#00FBD9", contrastText: "#FF00FF" },
		secondary: { main: "#FF00FF", contrastText: "#00FBD9" },
		mode: 'dark',
		text: {
			primary: "#00FBD9",
			secondary : "#fff",
			contrastText: "#FF00FF",
			header: "#00FBD9",
			graphLabel: "#00FBD9",
			link: "#FF00FF",
			border: "#06dcbf",
			menuUnderline: "#06dcbf",
			menuItemSelected: "#fff",
			menuItemGlow: "#06dcbf",
		},
		background: {
			default: "#2b2a2a",
			paper: "#2b2a2a", //"#101010",
			sidebar: "#2b2a2a",
			header: "#101010",
			// card: "#343333",
			card: "#2b2a2a",
			inputLabel: "#4b4b4b",
			category: "#4b4b4b",
		},
		divider: "#262626",
		boxborder: "#767676"
	},
	typography: {
		fontFamily: [
			'Plus Jakarta Sans',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Arial',
			'sans-serif',
			'Roboto',
			'"Helvetica Neue"',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
	}
};

export const lightTheme = {
	palette: {
		primary: { main: "#2b2a2a", contrastText: "#FF00FF" },
		secondary: { main: "#FF00FF", contrastText: "#00FBD9" },
		mode: 'light',
		text: {
			primary: "#2b2a2a",//"#06dcbf",
			secondary : "#2b2a2a",
			header: "rgba(0, 0, 0, 0.87)",
			graphLabel: "#fff",
			link: "#90caf9",
			border: "#06dcbf",
			menuUnderline: "#06dcbf",
			menuItemSelected: "#2b2a2a",
			menuItemGlow: "#000",
		},
		background: {
			default: "#fff",
			paper: "#fff",
			sidebar: "#fff",
			header: "#fff",
			card: "#fff",
			inputLabel: "#fff",
			category: "#eee",
			// default: "#eee",
			// paper: "#fff",
			// sidebar: "#eee",
			// header: "#eee",
			// card: "#fff",
			// inputLabel: "#fff"
		},
		divider: "#eee",
		boxborder: "#cccccc"
	},
	typography: {
		fontFamily: [
			'Plus Jakarta Sans',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Arial',
			'sans-serif',
			'Roboto',
			'"Helvetica Neue"',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
	}
};

export const contentBoxStyle = {
	flexGrow: 1,
	color: "text.primary",
	padding: "0em 4em 0 4em",
	display: "flex",
	flexDirection: "column"
};

export const borderStyle = {
	borderColor: "text.border"
};

export const greyBorderStyle = {
	borderColor: "text.border"
};

export const defaultLogoUrls = {
	"light": "/dark-cymplify-logo-small.png",
	"dark": "/light-cymplify-logo-small.png"
};

export const sidebarLogoUrls = {
	"light": "/dark-cymplify-logo-sidebar.png",
	"dark": "/light-cymplify-logo-sidebar.png"
};

export const cardStyle = {
	backgroundColor: "background.card",
	margin: "0.75em",
	borderRadius: "0.75em",
	height: "90%"
};

export const ThemeModeContext = createContext(null);
